import React, { Suspense, lazy } from "react";
import { IdCheckLoopServiceType } from "../../lib/types/runtimeTypes";

import { IDCheckLoopResponse, VerificationService } from "../../lib/types/types";

import { QUERY_STRING_ID_CHECK_LOOP_SERVICE_TYPE_OVERRIDE } from "../../constants";
import { getQueryOrOption } from "../../lib/ServerApi/TestingRouteOverrides";
import { LoadingScreenComponent } from "../LoadingScreen/LoadingScreenComponent";

const StepIDCheckLoopOnfido = lazy(
  () => import("./Onfido/StepIDCheckLoopOnfido/StepIDCheckLoopOnfido"),
);
const StepIDCheckLoopRegula = lazy(
  () => import("./Regula/StepIDCheckLoopRegulaComponent/StepIDCheckLoopRegula"),
);

export interface StepIDCheckLoopComponentProps {
  verificationService: VerificationService;
}

/**
 * The idCheckLoop step consists of two 3rd party identity verification services. One is `Onfido`, which performs a
 * governemnt ID based identity confirmation, in addition to a liveness check. The other is `Regula`, which only
 * performs identity confirmation without a liveness check. The verification API's serviceType property denotes
 * them as such.
 */
const StepIDCheckLoop = ({ verificationService }: StepIDCheckLoopComponentProps) => {
  const verificationResponse = verificationService.verificationResponse as IDCheckLoopResponse;
  const mockIdCheckLoopServiceType = getQueryOrOption(
    QUERY_STRING_ID_CHECK_LOOP_SERVICE_TYPE_OVERRIDE,
  );

  const idCheckServiceType = mockIdCheckLoopServiceType || verificationResponse.idCheckServiceType;

  return (
    <Suspense
      fallback={
        <div className="sid-l-horz-center">
          <LoadingScreenComponent step="idCheckLoop" />
        </div>
      }
    >
      {idCheckServiceType === IdCheckLoopServiceType.ID_CHECK ? (
        <StepIDCheckLoopRegula verificationService={verificationService} />
      ) : (
        <StepIDCheckLoopOnfido verificationService={verificationService} />
      )}
    </Suspense>
  );
};

export const StepIDCheckLoopComponent = StepIDCheckLoop;
